export interface IPropsExploreEbookCollection {
  index: number;
  whitelistUserIds?: string[];
  onDeleteSectionItem?: (idx?: number) => void;
  expanded?: boolean;
}

const ExploreEbookCollection = ({ index, onDeleteSectionItem, expanded }: IPropsExploreEbookCollection) => {
  // const { watch, setValue, register } = useFormContext();

  /* ----- RHF user-IDs ----- */
  // const whitelistUserIds: (string | undefined)[] = useMemo(() => watch(`configItems.${index}.whitelistUserIds`) || [], [watch, index]);

  /* ----- visible text for each box (5 slots) ----- */
  // const [searchText, setSearchText] = useState<string[]>(() => Array.from({ length: 5 }, (_, i) => whitelistUserIds[i] ?? ''));
  // useEffect(() => {
  //   setSearchText((prev) => prev.map((t, i) => (whitelistUserIds[i] !== undefined ? whitelistUserIds[i]! : t)));
  // }, [whitelistUserIds]);

  /* keep track of which input we *just* selected */
  // const ignoreNextEmpty = useRef<Set<number>>(new Set());

  /* ----- GraphQL search ----- */
  // const [q, setQ] = useState('');
  // const { searchUsers, fetchSearchUsers } = useQuerySearchUsers();
  // useEffect(() => void fetchSearchUsers({ q, filter: { type: UserType.Individual } }), [fetchSearchUsers, q]);

  // const mappedUserItems = useMemo(
  //   () =>
  //     searchUsers?.edges.map(({ node }) => ({
  //       label: node?.displayName || '',
  //       value: node?._id || '',
  //       node: <DropdownUserRowItem profileImage={node?.profileImage || ''} displayName={node?.displayName || ''} userName={node?.username || ''} isPremium={node?.isPremium} />,
  //     })) || [],
  //   [searchUsers],
  // );

  /* ----- render ----- */
  return (
    <div className="flex justify-between space-x-16">
      {/* ⬇️  overflow-visible here so the menu can escape the card */}
      <div className="w-full collapse overflow-visible relative ">
        <input type="checkbox" className="peer" defaultChecked={expanded} />

        <div
          className="collapse-title bg-systemGrays08FillQuaternary text-systemGrays01LabelPrimary
                        peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary
                        flex justify-between after:content-['+'] peer-checked:after:content-['-']
                        ease-out duration-300"
        >
          <span>Explore Ebook Collection</span>
        </div>

        <div className="collapse-content overflow-hidden peer-checked:overflow-visible text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary">
          <div className="space-y-8 py-8">
            {/*
            {Array.from({ length: 5 }).map((_, i) => (
              <input key={`hidden-${i}`} type="hidden" {...register(`configItems.${index}.whitelistUserIds.${i}`)} value={whitelistUserIds[i] ?? ''} />
            ))}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="relative">
                  <SearchInputDropdown
                    items={mappedUserItems}
                    value={searchText[i]}
                    onChange={(text) => {
                      if (text === '' && ignoreNextEmpty.current.has(i)) {
                        ignoreNextEmpty.current.delete(i); // consume the token
                        return; // nothing is erased
                      }

                      // if the user back-spaces everything, clear the RHF slot
                      if (text === '') {
                        setValue(`configItems.${index}.whitelistUserIds.${i}`, '', { shouldValidate: true, shouldDirty: true });
                      } else {
                        // write *any* non-empty typing into RHF as well
                        setValue(`configItems.${index}.whitelistUserIds.${i}`, text, { shouldValidate: true, shouldDirty: true });
                      }

                      setQ(text);
                      setSearchText((prev) => prev.map((t, idx) => (idx === i ? text : t)));
                    }}
                    onClickMenuItem={(item) => {
                      setValue(`configItems.${index}.whitelistUserIds.${i}`, item.value, { shouldValidate: true, shouldDirty: true });

                      setSearchText((prev) => prev.map((t, idx) => (idx === i ? item.value : t)));

                      ignoreNextEmpty.current.add(i);

                      setQ('');
                    }}
                    menuClassName="absolute z-50 w-full max-h-60 overflow-auto bg-white shadow-lg"
                    placeholder={`User #${i + 1}`}
                  />
                </div>
              ))} 
            </div>*/}

            {onDeleteSectionItem && (
              <button className="mt-4 text-red-500 hover:underline" onClick={() => onDeleteSectionItem(index)}>
                Delete
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreEbookCollection;
